export const verifyTencentEmail = (value) => {
  return /^\w+([\.-]?\w+)*@tencent.com$/.test(value)
}

export const verifyEmail = (value) => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
}

